import type { Presentation } from '@magicdoor/magic-use-case-solid';
import { ManagedStatus } from '@magicdoorinc/avm';
import type { MainAppState } from '~/state/mainAppState';
import { VersionStatus } from '~/use-cases/types/Version';
import type { PresentableVersion } from './types/PresentableVersion';

export const presentVersion: Presentation<MainAppState, PresentableVersion> = (state) => {
  const version = state.user.version;
  if (version && !version.isReachable) {
    return { status: ManagedStatus.Maintenance };
  }
  return {
    status: version?.status === VersionStatus.Maintenance ? ManagedStatus.Maintenance : ManagedStatus.Ok,
  };
};
